import React, { useEffect, useState } from "react";
import { Column } from "primereact/column";
import localeText from "../../../../../../locale";
import { DataTable } from "primereact/datatable";
import { DataView, DataViewLayoutOptions } from "primereact/dataview";
import { FilterMatchMode } from "primereact/api";
import { useHistory, useLocation, Link } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import BanggoodService from "../../../../../../service/BanggoodService";
import { useDebounce } from "../hooks/useDebounce";
import { classNames } from "primereact/utils";
import PaginationComponent from "./PaginationComponent"

const ProductsTable = (props) => {
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [products, setProducts] = useState(props.products);
  const [totalProducts, setTotalProducts] = useState(props.totalProducts);
  const [currentPage, setCurrentPage] = useState(props.currentPage);


  const imageBodyTemplate = (product) => {
    return <img src={Object.values(product.image_list.gallery)[0]} alt={product.product_name} className="w-6rem shadow-2 border-round" />;
};
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  const debouncedFetch = useDebounce(async (e) => {
    try {
      const banggoodService = new BanggoodService();
      const product_list = await banggoodService.getProduct(e);
      setProducts(product_list.products);
      setTotalProducts(product_list.totalProducts)
      setCurrentPage(product_list.page)
    } catch (error) {
      console.log(error);
    }
  });
  const onGlobalFilterChange = async (e) => {
    const value = e.target.value;
    setGlobalFilterValue(value);
    debouncedFetch(value);
  };
  const onPageChange = async (e) => {
    props.onPageChange(e)
  };


  return (
    <>
      <div className="flex flex-column">
        <InputText
          className="mb-3 p-inputtext-lg"
          name="tracking"
          value={globalFilterValue}
          onInput={onGlobalFilterChange}
          placeholder={localeText("searchProducts")}
        />
      </div>
      <DataTable
        value={products}
        filterDisplay="row"
        currentPageReportTemplate={localeText("showingFirstToLast")}
      >
        <Column header="Image" body={imageBodyTemplate}></Column>
        <Column
          style={{ width: "80%" }}
          field="product_name"
          header="Produto"
          sortable
          filterPlaceholder={localeText("searchProducts")}
        />
        <Column
          style={{ width: "15%" }}
          className=""
          body={(row) => {
            return (
              <>
                <Link to={`/dashboard-dropshippingproduct?id=${row.product_id}`}>
                  <Button label={localeText("seeProduct")} className="p-button-success" />
                </Link>
              </>
            );
          }}
        />

      </DataTable>
      <PaginationComponent data={products} itemsPerPage={10} currentPage={currentPage} totalRows={totalProducts} onPageChange={onPageChange}></PaginationComponent>
    </>
  );
};

export default ProductsTable;
